import React from "react";
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextButton from "../../partials/NextButton";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";

import StepLayout from '../../../containers/StepLayout';
/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();
/*
    PhoneVerification view that displays the Phone Verification page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class PhoneVerification extends React.Component {

  constructor(){
    super();

    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleMobileChange = this.handleMobileChange.bind(this);
    this.handleOfferChange = this.handleOfferChange.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Verify Information");
    this.props.setStep(1);

    //TODO: need to grab phone number from API
    if (this.props.phn.length === 0){
      this.props.updateForm("phn", "512-123-4567");
    } else {
      if (this.props.ismobilechecked2){
        let querydataanswer = "[data-answer='Is Mobile']";
        if (!this.props.ismobile2)
          querydataanswer = "[data-answer='Not Mobile']";
        else
          document.getElementById("textmessages").classList.remove("hidden");
        document.querySelectorAll(querydataanswer)[0].classList.add('activated');
        document.getElementById("receiveofferscheck").classList.remove("hidden");
        if (this.props.allphonechecked){
          querydataanswer = "[data-answer='Yes Offers']";
          if (!this.props.receiveoffers)
            querydataanswer = "[data-answer='No Offers']";
          document.querySelectorAll(querydataanswer)[0].classList.add('activated');
        }
      }
    }
  }

  componentWillUnmount() {
    window.scrollTo(0, 0);
  }
  editInfo(e){
    if (e.target.parentNode.classList.contains('editpen')){
      e.target.parentNode.parentNode.classList.add("hidden");
      e.target.parentNode.parentNode.nextSibling.classList.remove("hidden");
    } else if (e.target.classList.contains('editpen')){
      e.target.parentNode.classList.add("hidden");
      e.target.parentNode.nextSibling.classList.remove("hidden");
    }
    document.querySelector("label[for='phn']").focus();
  }

  handlePhoneChange(e) {
    let phn = e.target.value;

    phn = phn.replace(/\D/g, '');
    let split = 3;
    let chunk = [];
    for (let i = 0; i < phn.length; i += split) {
      split = (i <= 3) ? 3 : 4;
      chunk.push( phn.substr( i, split ) );
    }
    if (chunk[0]) chunk[0] = validation.checkPhoneNum(chunk[0], 200);
    let tmp = chunk.join("-");
    this.props.updateForm("phn", tmp);

    let phntip = document.getElementById("phntip");
    const phnlabel = document.querySelector("label[for='phn']");

    if (validation.validatePhone(phn)){
      phntip.classList.add("hidden");
      phntip.innerHTML = "";
      phnlabel.classList.add("activeaddy");
    } else {
      phnlabel.classList.remove("activeaddy");
    }
  }

  handlePhoneBlur(e) {
    let phn = e.target.value;
    let phntip = document.getElementById("phntip");

    if (!validation.validatePhone(phn)){
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter a valid phone number.";
    } else {
      document.getElementById("phnfield").classList.add("hidden");
      document.getElementById("phnbox").classList.remove("hidden");
    }
  }

  handlePhoneKeyUp(e) {
    // eslint-disable-next-line
    if(e.keyCode == 13 || e.keyCode == 45){
      let phn = e.target.value;
      this.props.updateForm("phn", phn);

      let phntip = document.getElementById("phntip");
      const phnlabel = document.querySelector("label[for='phn']");

      if (validation.validatePhone(phn)){
        phntip.classList.add("hidden");
        phntip.innerHTML = "";
        phnlabel.classList.add("active");
        document.getElementById("phnfield").classList.add("hidden");
        document.getElementById("phnbox").classList.remove("hidden");
      } else {
        phnlabel.classList.remove("active");
      }
    }
  }

  handleMobileChange(e) {
    e.preventDefault();

    this.props.updateForm("ismobilechecked2", true);

    [].forEach.call( document.querySelectorAll('.ismobilebtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");

    const textmessages = document.getElementById("textmessages");
    if (e.target.dataset.answer === "Not Mobile"){
      this.props.updateForm("ismobile2", false);
      textmessages.classList.add("hidden");
    } else {
      this.props.updateForm("ismobile2", true);
      textmessages.classList.remove("hidden");
    }

    const receiveofferschk = document.getElementById("receiveofferscheck")
    receiveofferschk.classList.remove("hidden");

    if (window.pageYOffset < 250)
      scroll.scrollTo(250, {duration: 1000});
  }

  handleOfferChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.offerbtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");
    if (e.target.dataset.answer === "No Offers"){
      this.props.updateForm("receiveoffers", false);
    } else {
      this.props.updateForm("receiveoffers", true);
    }

    this.props.updateForm("allphonechecked", true);

    if (window.pageYOffset < 350)
      scroll.scrollTo(350, {duration: 800});
  }

  render() {

    const nextStep = 2;
    const nextLink = "/agreements";
    const btnText = "Continue";
    const btnClasses = "btn next-step";

      return (
            <StepLayout>
              <div className="container" id="stepper-step-3">
                  <div className="text-center topcopy">
                      <h1>How can we reach you?</h1>
                      <h5>We need a valid phone number to process your application. Confirm it below to make sure we got it right.</h5>
                  </div>
                  <form className="flowform">
                      <input type="hidden" value="needed for disabling autocomplete" />
                      <div className="text-center reachingyouphone"><img className="phoneicon style-svg" src="/images/svg/simpleapplication.svg" height="75px" alt="phone icon" /></div>
                      <div className="detailsbox text-center">
                        <div id="phnbox">
                          <p>{this.props.phn}</p>
                          <svg className="editpen" onClick={this.editInfo} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                            <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                          </svg>
                        </div>
                        <div id="phnfield" className="form-group hidden">
                          <label htmlFor="phn">
                            <div className="errortip hidden" id="phntip">
                                Please provide a valid phone number.
                            </div>
                            <input type="tel" name="phn" id="phn" autoComplete="phn" className="form-control" placeholder="eg: 512-123-4567" value={this.props.phn} onChange={this.handlePhoneChange} onBlur={this.handlePhoneBlur} onKeyUp={this.handlePhoneKeyUp} maxLength="12"/>
                          </label>
                        </div>
                      </div>

                      <p className="ptop text-center">If this is not your primary number, you can go ahead and change it.</p>

                      <div id="mobilenumbercheck" className="text-center">
                          <p className="buttontitle">Is this your mobile number?</p>
                          <div className="button-group padtop15">
                            <a className="btn yesno ismobilebtn" id="nomobile" data-answer="Not Mobile" onClick={this.handleMobileChange} tabIndex="2">No</a>
                            <a className="btn yesno ismobilebtn" id="yesmobile" data-answer="Is Mobile" onClick={this.handleMobileChange} tabIndex="3">Yes</a>
                          </div>
                      </div>
                      <div id="receiveofferscheck" className="hidden text-center">
                          <p className="buttontitle">Would you like to receive special offers and promotions via <span id="textmessages" className="hidden">text messages and/or</span> phone calls?</p>
                          <p className="nobottom"><AlertDialogSlide linkText="Check out the terms." tip="smsterms" /></p>
                          <div className="button-group padtop15">
                            <a className="btn yesno offerbtn" id="nooffer" data-answer="No Offers" onClick={this.handleOfferChange} tabIndex="4">No</a>
                            <a className="btn yesno offerbtn" id="yesoffer" data-answer="Yes Offers" onClick={this.handleOfferChange} tabIndex="5">Yes</a>
                          </div>
                      </div>

                      <NextButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.props.allphonechecked} hideNext={!this.props.ismobilechecked2} step={nextStep} id="phoneallchecked" tabIndex="6"/>
                  </form>
              </div>
            </StepLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    phn: state.FormReducer.phn,
    ismobile2: state.FormReducer.ismobile2,
    receiveoffers: state.FormReducer.receiveoffers,
    ismobilechecked2: state.FormReducer.ismobilechecked2,
    allphonechecked: state.FormReducer.allphonechecked,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step))
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneVerification)



// WEBPACK FOOTER //
// ./src/components/views/PhoneVerification/index.js